import {
  Component,
  PLATFORM_ID,
  afterNextRender,
  Renderer2,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'infoWhats';
  private platformId = inject(PLATFORM_ID);
  private renderer = inject(Renderer2);
  constructor() {
    afterNextRender(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.setupDarkModeListener();
      }
    });
  }

  private setupDarkModeListener(): void {
    const darkModeMediaQuery = window.matchMedia(
      '(prefers-color-scheme: dark)'
    );
    this.toggleDarkMode(darkModeMediaQuery.matches);

    darkModeMediaQuery.addEventListener('change', (e) => {
      this.toggleDarkMode(e.matches);
    });
  }

  private toggleDarkMode(isDark: boolean): void {
    if (isDark) {
      this.renderer.addClass(document.documentElement, 'dark');
    } else {
      this.renderer.removeClass(document.documentElement, 'dark');
    }
  }
}
